import { useEffect } from 'react';
import type { Ref } from 'react';

import DashboardSection from './DashboardSection';
import DashboardItemSegmentsTable from './DashboardItemSegmentsTable';
import type { useDashboardSegmentData } from '../hooks/useDashboardSegmentData';
import { DASHBOARD_ITEM_SEGMENTS_ID } from '../dashboard.constants';
import type { EDashboardSegmentKey, TDashboardSegmentView } from '../types/dashboard.types';

type TProps = {
  segments: TDashboardSegmentView[];
  segmentData: ReturnType<typeof useDashboardSegmentData>;
  sectionRef?: Ref<HTMLDivElement>;
  selection: {
    key: EDashboardSegmentKey;
    onChange: (segmentKey: EDashboardSegmentKey) => void;
  };
  pagination: {
    page: number;
    pageSize: number;
    onPageChange: (page: number) => void;
    onReplacePage: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
  };
};

const DashboardItemSegments = ({ segments, segmentData, sectionRef, selection, pagination }: TProps) => {
  const { page, pageSize, onPageChange, onReplacePage, onPageSizeChange } = pagination;

  useEffect(() => {
    if (!segmentData.segmentPage || segmentData.isPlaceholderData) return;
    const lastPage = Math.max(1, Math.ceil(segmentData.segmentPage.totalCount / pageSize));
    if (page > lastPage) onReplacePage(lastPage);
  }, [onReplacePage, page, pageSize, segmentData.isPlaceholderData, segmentData.segmentPage]);

  return (
    <DashboardSection id={DASHBOARD_ITEM_SEGMENTS_ID} sectionRef={sectionRef} tabIndex={-1} title="Item segments">
      <DashboardItemSegmentsTable
        segments={segments}
        selection={selection}
        pageState={segmentData}
        pagination={{
          page,
          pageSize,
          onPageChange,
          onPageSizeChange,
        }}
      />
    </DashboardSection>
  );
};

export default DashboardItemSegments;
